module.exports = __webpack_public_path__ + "static/media/Vex_0.bafc1982.jpg";